import React from 'react'
import { Row } from "react-bootstrap";
import { HashLink } from "react-router-hash-link";
import Styles from "./PageNotFound.module.css";
import { Helmet } from "react-helmet";

function PageNotFound() {
    return (
        <Row className={Styles.ProjectsPage}>
          <Helmet>
            <title>404 Page Does Not Exist - Matamando Kalilani</title>
            <meta name="description" content="This page does not exist." />
            <meta name="robots" content="index, follow" />
          </Helmet>{" "}
          <Row className={Styles.ComingSoonBox}>
          <h1 className={Styles.ComingSoonText}>404 -  Page does not exist</h1>
            {/* <h1 className={Styles.ComingSoonText}>You seem to be lost.</h1> */}
            <div
              style={{
                width: "max-content",
                marginLeft: "auto",
                marginRight: "auto",
                marginTop: "25px",
              }}
            >
              <HashLink style={{ textDecoration: "none" }} smooth to="/#top">
                <div className={Styles.GoBackHomeBox}>
                  <div
                    className="contact-button"
                    style={{ width: "max-content", marginLeft: "0px" }}
                    onClick={() => {}}
                  >
                    <span class="material-icons">arrow_back_ios</span>
                    <p
                      style={{
                        marginRight: "20px",
                        marginLeft: "5px",
                        fontSize: "18px",
                      }}
                    >
                      Go Back Home
                    </p>
                  </div>
                </div>
              </HashLink>
            </div>
          </Row>
        </Row>
      );
}

export default PageNotFound
